import { parseQueryString } from '@zg-rentals/string-utils';

import StringConstants from '../constants/StringConstants';
import QueryConstants from '../constants/QueryConstants';

const contextUtils = {
  /**
   * Gets the marketing path value
   *
   * @param {string} search - The search query params
   * @return {string}
   */
  getMarketingPathVal(search: string) {
    const queryParams = parseQueryString(search);
    return queryParams[QueryConstants.MARKETING_PATH];
  },

  /**
   * Checks if the marketing search query parameter is application.
   *
   * @param {string} search - The search query params
   * @return {bool}
   */
  isFromMarketingApplicationsRoute(search: string) {
    const queryParams = parseQueryString(search);
    return queryParams[QueryConstants.MARKETING_PATH] === StringConstants.MARKETING_PATH.APPLICATIONS;
  },

  /**
   * Checks if the marketing search query parameter is payment.
   *
   * @param {string} search - The search query params
   * @return {bool}
   */
  isFromMarketingPaymentsRoute(search: string) {
    const queryParams = parseQueryString(search);
    return queryParams[QueryConstants.MARKETING_PATH] === StringConstants.MARKETING_PATH.PAYMENTS;
  },

  /**
   * Checks if the marketing search query parameter is leases.
   *
   * @param {string} search - The search query params
   * @return {bool}
   */
  isFromMarketingLeasesRoute(search: string) {
    const queryParams = parseQueryString(search);
    return queryParams[QueryConstants.MARKETING_PATH] === StringConstants.MARKETING_PATH.LEASES;
  },

  /**
   * Checks if the redirect search query parameter is payments.
   *
   * @param {string} search - The search query params
   * @return {bool}
   */
  isRedirectToPayments(search: string) {
    const queryParams = parseQueryString(search);
    return queryParams[QueryConstants.REDIRECT_TO] === StringConstants.REDIRECT_TO.PAYMENTS;
  },
};

export default contextUtils;
